import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { of } from 'rxjs';
import { map, switchMap, catchError, pairwise } from 'rxjs/operators';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';
import { AccountingService } from '../accounting.service';
import { ModalCancelComponent } from '../modal-cancel/modal-cancel.component';
import { ModalPrintComponent } from '../modal-print/modal-print.component';

@Component({
  selector: 'app-create-invoice',
  templateUrl: './create-invoice.component.html',
  styleUrls: ['./create-invoice.component.scss']
})
export class CreateInvoiceComponent implements OnInit {

  isLoading: boolean = false;
  isEdit: boolean = false;
  id: string;
  partial: boolean = false;
  ver: string = '';
  invoiceDetail: any;
  date: any;

  invoiceForm: FormGroup;
  tax: boolean = false;
  vat: boolean = false;
  total: number = 0;
  discount: number = 0;
  priceWithoutVat: number = 0;
  taxPrice: number = 0;
  vatPrice: number = 0;
  totalNetPrice: number = 0;
  balance: number = 0;

  hasChange: boolean = false;

  printDetail: any;
  isPrint: boolean = false;
  canPrint: boolean = false;
  printData: any;

  installmentList = [
    { label: 'ตามจำนวนเงิน', value: 'total' },
    { label: 'ตามเปอร์เซ็นต์', value: 'percent' },
  ];

  column = [
    { header: 'เลขที่', class: 'col-1' },
    { header: 'รายการ', class: 'col-4' },
    { header: 'จำนวน', class: 'col-1' },
    { header: 'ราคาต่อหน่วย', class: 'col-2' },
    { header: 'ส่วนลด', class: 'col-1' },
    { header: 'จำนวนเงิน', class: 'col-2' },
    { header: '', class: 'col-1' },
  ];

  formatterPrice = (value: number): string =>
    `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  constructor(
    private fb: FormBuilder,
    private gobalFunctionService: GobalFunctionService,
    public matDialog: MatDialog,
    private accountService: AccountingService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.id = new URL(location.href).searchParams.get('id');
    this.isEdit = JSON.parse(new URL(location.href).searchParams.get('isEdit'));
    this.partial = JSON.parse(new URL(location.href).searchParams.get('Partial'));
    this.ver = new URL(location.href).searchParams.get('version');

    if (this.isEdit) {
      this.gobalFunctionService.setTitle(`ใบแจ้งหนี้ ${this.id}`);
      this.getDetailInvoice(this.id);
    } else {
      this.gobalFunctionService.setTitle('สร้างใบแจ้งหนี้');
      this.getDetailFromQuotation();
    }

  }

  getDetailFromQuotation() {
    this.isLoading = true;

    this.accountService.getDetailQuotation(this.id, this.ver).pipe(
      map(q => {
        // console.log(q.result);
        this.invoiceDetail = q.result;

        this.date = [this.invoiceDetail.QUOTATION_START, this.invoiceDetail.QUOTATION_END];

        if (this.partial) {
          this.invoiceForm = this.fb.group({
            accountId: [this.invoiceDetail.ACCOUNTING_ID, Validators.required],
            accountName: [this.invoiceDetail.ACCOUNTING_NAME, Validators.required],
            name: [this.invoiceDetail.CUSTOMER_NAME, Validators.required],
            note: [''],
            detail: [this.invoiceDetail.CUSTOMER_DETAIL, Validators.required],
            title: [this.invoiceDetail.TITLE, Validators.required],
            taxId: [this.invoiceDetail.TAX_NO, [Validators.required, Validators.pattern("([0-9]{13}$)")]],
            date: [this.invoiceDetail.QUOTATION_START, Validators.required],
            dateEnd: [this.invoiceDetail.QUOTATION_END, Validators.required],
            total: ['', Validators.required],
            lists: this.fb.array([])
          });
          this.getDetailPartial(this.id, this.ver);
        } else {
          this.invoiceForm = this.fb.group({
            accountId: [this.invoiceDetail.ACCOUNTING_ID, Validators.required],
            accountName: [this.invoiceDetail.ACCOUNTING_NAME, Validators.required],
            name: [this.invoiceDetail.CUSTOMER_NAME, Validators.required],
            note: [''],
            detail: [this.invoiceDetail.CUSTOMER_DETAIL, Validators.required],
            title: [this.invoiceDetail.TITLE, Validators.required],
            taxId: [this.invoiceDetail.TAX_NO, [Validators.required, Validators.pattern("([0-9]{13}$)")]],
            date: [this.invoiceDetail.QUOTATION_START, Validators.required],
            dateEnd: [this.invoiceDetail.QUOTATION_END, Validators.required],
            lists: this.fb.array([])
          });
        }

        this.addGroup();
        // console.log(this.invoiceForm);
        this.onCreateGroupFormValueChange();

      }),
      catchError((err) => {
        alert(err.error.message);
        this.router.navigate(['/']);
        return of(null);
      })
    ).subscribe();
    setTimeout(() => {
      this.isLoading = false;
    }, 500)

  }

  getDetailInvoice(id) {
    this.isLoading = true;

    this.accountService.getDetailInvoice(id).pipe(
      map(q => {
        // console.log(q.result);
        this.invoiceDetail = q.result;

        this.date = [this.invoiceDetail.INVOICE_START, this.invoiceDetail.INVOICE_END];
        let notPartialForm = {
          accountId: [this.invoiceDetail.ACCOUNTING_ID, Validators.required],
          accountName: [this.invoiceDetail.ACCOUNTING_NAME, Validators.required],
          name: [this.invoiceDetail.CUSTOMER_NAME, Validators.required],
          note: [this.invoiceDetail.INVOICE_REMARK],
          detail: [this.invoiceDetail.CUSTOMER_DETAIL, Validators.required],
          title: [this.invoiceDetail.TITLE, Validators.required],
          taxId: [this.invoiceDetail.TAX_NO, [Validators.required, Validators.pattern("([0-9]{13}$)")]],
          date: [this.invoiceDetail.QUOTATION_START, Validators.required],
          dateEnd: [this.invoiceDetail.QUOTATION_END, Validators.required],
          lists: this.fb.array([])
        }
        let partialForm = {
          ...notPartialForm,
          total: [this.invoiceDetail.TOTAL, Validators.required],
        }

        if (this.partial) {
          this.invoiceForm = this.fb.group(partialForm);
          this.getDetailPartial(this.invoiceDetail.QUOTATION_NO, this.invoiceDetail.QUOTATION_VERSION);
        } else {
          this.invoiceForm = this.fb.group(notPartialForm);
        }
        this.addGroup();
        // console.log(this.invoiceForm);
        this.onCreateGroupFormValueChange();

        if (this.isPrint) {
          this.printPdf(this.printData);
        }

      }),
      catchError((err) => {
        alert(err.error.message);
        this.router.navigate(['/']);
        return of(null);
      })
    ).subscribe();
    setTimeout(() => {
      this.isLoading = false;
    }, 500)
  }

  getDetailPartial(id, ver) {
    this.accountService.getDetailPartial(id, ver).pipe(
      map(res => {
        this.balance = res.result.Quotation_Sum_Price - res.result.Partiel_Price;
      }),
      catchError(err => {
        alert(err.error.message);
        return of(false);
      })
    ).subscribe();
  }

  addGroup() {
    let invoice = this.isEdit ? this.invoiceDetail.invDetail : this.invoiceDetail.quoDetail;
    // invoice = this.isPrint ? this.invoiceDetail.invDetail : this.invoiceDetail.quoDetail;

    invoice.forEach(e => {
      // console.log(e);

      (<FormArray>this.invoiceForm.get("lists")).push(this.fb.group({
        list: [e.DESCRIPTION, [Validators.required]],
        number: [e.QTY, [Validators.required]],
        unitPrice: [e.UNIT_PRICE, [Validators.required]],
        discount: [e.DISCOUNT, [Validators.required]],
        totalWithoutDiscount: [e.UNIT_PRICE * e.QTY, Validators.required],
        total: [e.TOTAL]

      }));
    });
    this.getSummary(this.invoiceFormArray);
    if (this.invoiceDetail.INCLUDE_VAT === 1) {
      this.vat = true;
      this.calNetPrice();
    }
  }

  get invoiceFormArray(): FormArray {
    return this.invoiceForm.get('lists') as FormArray;
  }

  removeGroup(i, form) {
    (<FormArray>form.get("lists")).removeAt(i);

    this.getSummary(this.invoiceFormArray);
  }

  getClass() {
    if (!this.invoiceDetail) { return ''; }
    if (this.invoiceDetail.STATUS === 'Done') { return 'disable-display'; }
    if (this.invoiceDetail.STATUS === 'Cancel') { return 'disable-display'; }
  }

  selectDate(e, form) {
    // console.log(e[0]);
    // console.log(e[1]);

    form.patchValue({
      date: e[0],
      dateEnd: e[1]
    });
    form.get('date').updateValueAndValidity();
    form.get('dateEnd').updateValueAndValidity();
  }

  onCreateGroupFormValueChange() {
    const initialValue = this.invoiceForm.value;
    this.invoiceForm.valueChanges.subscribe(value => {
      this.hasChange = Object.keys(initialValue).some(key => this.invoiceForm.value[key] !== initialValue[key]);
    });

    // console.log(this.hasChange);

  }

  getTotal(form, i) {
    let number = form.value[i].number;
    let unitPrice = form.value[i].unitPrice;
    let discount = form.value[i].discount;
    let total = (unitPrice * number) - discount;
    let totalWithoutDiscount = unitPrice * number;

    form.at(i).patchValue({
      total: total,
      totalWithoutDiscount: totalWithoutDiscount
    })
    // console.log(form)
  }

  getSummary(form) {
    let priceWithoutVat = 0;
    let unitPrice = 0;
    let discount = 0;
    let totalWithoutDiscount = 0;
    let vatPrice = 0;
    let totalNetPrice = 0;

    form.value.forEach((e, i) => {
      unitPrice = unitPrice + e.unitPrice;
      discount = discount + e.discount;
      totalWithoutDiscount = totalWithoutDiscount + e.totalWithoutDiscount;
      priceWithoutVat = priceWithoutVat + e.total;
    });

    this.total = totalWithoutDiscount;
    this.discount = discount
    this.priceWithoutVat = priceWithoutVat;

    if (this.vat) {
      vatPrice = (priceWithoutVat * 7) / 100;
      totalNetPrice = priceWithoutVat + vatPrice;

    } else {
      totalNetPrice = priceWithoutVat;
      vatPrice = 0;
    }

    this.totalNetPrice = totalNetPrice;
    this.vatPrice = vatPrice;

  }

  calNetPrice() {
    if (this.vat) {
      this.vatPrice = (this.priceWithoutVat * 7) / 100;
      this.totalNetPrice = this.totalNetPrice + this.vatPrice;
    } else {
      this.totalNetPrice = this.priceWithoutVat;
      this.vatPrice = 0;
    }
  }

  detectNumber(e, formcontrol) {
    if (e < 0) {
      // this.evidenceForm.controls['TRANFER_HR'].setValue(0);
      formcontrol.setValue(0);
      // formcontrol.setErrors({'incorrect': true});
    }
  }

  checkPartialTotal(total, form) {
    // console.log(total);
    // console.log(form);
    let balances = this.isEdit ? (this.invoiceDetail.Unpaid_Amount + this.invoiceDetail.TOTAL) : this.balance;
    
    if (total > balances) {
      form.setErrors({ 'incorrect': true });
    }

  }

  save(form) {
    // console.log(form);

    this.isLoading = true;
    let body = {
      CREATE_TYPE: this.partial ? 'Partial' : 'Full',
      QUOTATION_NO: this.invoiceDetail.QUOTATION_NO,
      QUOTATION_VERSION: this.invoiceDetail.QUOTATION_VERSION,
      TOTAL_PRICE: this.partial ? form.total : this.totalNetPrice,
      INVOICE_REMARK: form.note,
      CUSTOMER_DETAIL: form.detail,
      INVOICE_START: form.date,
      INVOICE_END: form.dateEnd,
    }

    // console.log(body);

    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = 'modalConfirm';
    // dialogConfig.width = '650px';
    dialogConfig.autoFocus = false;
    dialogConfig.data = {
      title: 'บันทึกใบแจ้งหนี้',
      actionBtnText: 'บันทึก',
      cancleBtnText: 'ยกเลิก',
      description: `<h5 class="m-4">คุณต้องการบันทึกใบแจ้งหนี้ใช่หรือไม่</h5>`
    }
    const modal = this.matDialog.open(ModalComponent, dialogConfig);
    return modal.afterClosed().pipe(
      switchMap(res => {
        if (res) {
          return this.accountService.createInvoice(body).pipe(
            switchMap(res1 => {
              if (res1.success) {
                const dialogConfig1 = new MatDialogConfig();
                dialogConfig1.disableClose = true;
                dialogConfig1.id = 'modalConfirm';
                dialogConfig1.width = '400px';
                dialogConfig1.data = {
                  title: 'สำเร็จแล้ว',
                  description: `<img src="../../../assets/check.png" width="100px;" class="img-center">บันทึกใบเสร็จสำเร็จแล้ว`,
                  cancleBtnText: 'ยืนยัน',
                  customStyle: 'background-color: #58595B;'
                }

                const modal2 = this.matDialog.open(ModalComponent, dialogConfig1);
                return modal2.afterClosed().pipe(
                  map(res2 => {
                    // console.log(res2);
                    if (!res2) {
                      if (!this.isPrint) {
                        this.isLoading = false;
                        // window.opener.location.reload();
                        window.open('accounting?type=invoice', '_self');
                        // setTimeout(() => {
                        //   window.close()
                        // }, 100);
                      } else {
                        this.id = res1.result.INVOICE_NO;
                        this.getDetailInvoice(this.id);
                      }
                    }
                  })
                )
              }

            })
          )
        } else {
          this.isLoading = false;
          return of(null);
        }
      }),
      catchError((err) => {
        alert(err.error.message);
        this.router.navigate(['/']);
        return of(false);
      })
    ).subscribe();
  }

  update(form) {
    // console.log(form);

    this.isLoading = true;
    let body = {
      UPDATE_TYPE: this.partial ? 'Partial' : 'Full',
      INVOICE_NO: this.invoiceDetail.INVOICE_NO,
      INVOICE_REMARK: form.note,
      CUSTOMER_DETAIL: form.detail,
      INVOICE_START: form.date,
      INVOICE_END: form.dateEnd,
      TOTAL_PRICE: this.partial ? form.total : this.totalNetPrice,
    }

    // console.log(body);

    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = 'modalConfirm';
    // dialogConfig.width = '650px';
    dialogConfig.autoFocus = false;
    dialogConfig.data = {
      title: 'บันทึกใบแจ้งหนี้',
      actionBtnText: 'บันทึก',
      cancleBtnText: 'ยกเลิก',
      description: `<h5 class="m-4">คุณต้องการบันทึกใบแจ้งหนี้ใช่หรือไม่</h5>`
    }
    const modal = this.matDialog.open(ModalComponent, dialogConfig);
    return modal.afterClosed().pipe(
      switchMap(res => {
        if (res) {
          return this.accountService.updateInvoice(body).pipe(
            switchMap(res1 => {
              if (res1.success) {
                const dialogConfig1 = new MatDialogConfig();
                dialogConfig1.disableClose = true;
                dialogConfig1.id = 'modalConfirm';
                dialogConfig1.width = '400px';
                dialogConfig1.data = {
                  title: 'สำเร็จแล้ว',
                  description: `<img src="../../../assets/check.png" width="100px;" class="img-center">บันทึกใบเสร็จสำเร็จแล้ว`,
                  cancleBtnText: 'ยืนยัน',
                  customStyle: 'background-color: #58595B;'
                }

                const modal2 = this.matDialog.open(ModalComponent, dialogConfig1);
                return modal2.afterClosed().pipe(
                  map(res2 => {
                    // console.log(res2);
                    if (!res2) {
                      if (!this.isPrint) {
                        this.isLoading = false;
                        window.open('accounting?type=invoice', '_self');
                        // window.opener.location.reload();
                        // setTimeout(() => {
                        //   window.close()
                        // }, 100);
                      } else {
                        this.id = res1.result.INVOICE_NO;
                        this.getDetailInvoice(this.id);
                      }
                    }
                  })
                )
              }

            })
          )
        } else {
          this.isLoading = false;
          return of(null);
        }
      }),
      catchError((err) => {
        alert(err.error.message);
        this.isLoading = false;
        // this.router.navigate(['/']);
        return of(false);
      })
    ).subscribe();
  }

  cancel(id) {
    let body;
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.id = 'modalConfirm';
    dialogConfig.width = '650px';
    dialogConfig.autoFocus = false;
    dialogConfig.data = {
      id: id,
      type: 'invoice'
    }
    const modal = this.matDialog.open(ModalCancelComponent, dialogConfig);
    return modal.afterClosed().pipe(
      switchMap(res => {
        if (res.status) {
          // console.log(res);
          body = {
            INVOICE_NO: id,
            CANCEL_REMARK: res.value,
          }

          return this.accountService.cancelInvoice(body).pipe(
            switchMap(res1 => {
              if (res1.success) {
                const dialogConfig1 = new MatDialogConfig();
                dialogConfig1.disableClose = true;
                dialogConfig1.id = 'modalConfirm';
                dialogConfig1.width = '400px';
                dialogConfig1.data = {
                  title: 'สำเร็จแล้ว',
                  description: `<img src="../../../assets/check.png" width="100px;" class="img-center">ยกเลิกใบแจ้งหนี้สำเร็จแล้ว`,
                  cancleBtnText: 'ยืนยัน',
                  customStyle: 'background-color: #58595B;'
                }

                const modal2 = this.matDialog.open(ModalComponent, dialogConfig1);
                return modal2.afterClosed().pipe(
                  map(res2 => {
                    // console.log(res2);
                    if (!res2) {
                      this.isLoading = false;
                      location.reload();
                    }
                  })
                )
              }
            })
          )
        } else {
          return of(null);
        }
      }),
      catchError((err) => {
        alert(err.error.message);
        this.router.navigate(['/'])
        return of(false);
      })
    ).subscribe();
  }

  print(form) {
    this.isLoading = true;
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.id = 'modalConfirm';
    dialogConfig.width = '400px';
    dialogConfig.autoFocus = false;
    dialogConfig.data = {
      type: 'invoice',
    };

    const modal = this.matDialog.open(ModalPrintComponent, dialogConfig);
    return modal.afterClosed().pipe(
      map(print => {
        if (print.status) {
          this.isPrint = true;
          this.printData = print;

          if (!this.isEdit) {
            this.isEdit = true;
            this.save(form);
          } else {
            if (this.invoiceDetail.STATUS === 'Wait' && !this.hasChange) {
              // console.log('AAAA');

              this.printPdf(this.printData);
            } else {
              // console.log('TG');
              this.update(form);
            }
          }

        } else {
          this.isLoading = false;
          return of(null);
        }
      })
    ).subscribe();
  }

  printPdf(print) {
    //const {printType,titleType} = print 
    let total = 0,
      discount = 0,
      priceWithoutVat = 0,
      vatPrice = 0,
      totalNetPrice = 0;

    this.invoiceDetail.invDetail.forEach(e => {
      total = total + (e.TOTAL + e.DISCOUNT);
      discount = discount + e.DISCOUNT;
      priceWithoutVat = priceWithoutVat + e.TOTAL;
    });

    if (this.vat) {
      vatPrice = (priceWithoutVat * 7) / 100;
      totalNetPrice = priceWithoutVat + vatPrice;

    } else {
      totalNetPrice = priceWithoutVat;
      vatPrice = 0;
    }

    let data = {
      detail: this.invoiceDetail,

      price: {
        total: total,
        discount: discount,
        priceWithoutVat: priceWithoutVat,
        vatPrice: vatPrice,
        totalNetPrice: totalNetPrice,
      },
      type: 'invoice',
      note: this.invoiceForm.value.note,
    }
    // this.printDetail = {
    //   printType,
    //   titleType,
    //   printData: data,
    // }
    this.printDetail = {
      printType: print.printType,
      titleType: print.titleType,
      printData: data,
    }
    this.canPrint = true;

    setTimeout(() => {
      this.isPrint = false;
      this.canPrint = false;
      this.isLoading = false;

      if ((this.isEdit && this.hasChange) || !this.isEdit) {
        window.open(`/accounting/create-invoice?isEdit=true&id=${this.id}`, '_self');
      }

    }, 1000);
    // console.log(print);
  }

  close() {
    window.close();
  }
}
